module.exports = __webpack_public_path__ + "media/src/images/student/cat-6c48e1c10cfc6ef6cffa0c1ccc9a9430.png";